import React, { Component } from "react";
import { Link } from "react-router-dom";
import Price from "../Price/Price";
import http from "../Http/Http";
import validator from "../Validators/Validators";
import PropTypes from "prop-types";
import "./ConfirmTransfer.css";

class ConfirmTransfer extends Component {
  constructor() {
    super();

    this.state = {
      amount: "",
      from: "",
      to: "",
      name: "",
      phoneNumber: "",
      description: "",
      pin: "",
      errors: {
        pin: false
      },
      isSubmitting: false,
      isSubmitted: false,
      isTransferred: false
    };

    this.validateForm = this.validateForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.transfer = this.transfer.bind(this);
  }

  componentDidMount() {
    const { to, amount, description } = this.props.match.params;

    this.setState({
      amount: amount ? amount : "",
      description: description ? description : ""
    });

    // set from-tag
    const signerHandle = localStorage.getItem("signerHandle");

    http
      .get(`/wallet/$${to}`)
      .then(response => {
        // get the default signer from the response
        const signerId = response.data.default;

        if (signerId) {
          return signerId;
        } else {
          throw Error("No default signer");
        }
      })
      .then(signerId => {
        return http.get(`/signer/${signerId}`);
      })
      .then(response => {
        const name = response.data.labels.firstName;

        if (name) {
          this.setState({
            name,
            phoneNumber: to,
            to: "$" + to,
            from: signerHandle
          });
        } else {
          throw Error("No name configured for this signer");
        }
      })
      .catch(() => {});
  }

  handleChange(event) {
    const target = event.target;

    this.setState(
      {
        [target.name]: target.value
      },
      () => {
        if (this.state.isSubmitted) {
          this.validateForm();
        }
      }
    );
  }

  validateForm(onValidForm) {
    const errors = {
      pin: !validator.isValidPin(this.state.pin)
    };

    this.setState({ errors });

    const errorKeys = Object.keys(errors).filter(key => errors[key]);

    // invoke callback function when form has no errors
    if (onValidForm && errorKeys.length === 0) {
      onValidForm();
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ isSubmitted: true });

    this.validateForm(this.transfer);
  }

  transfer() {
    this.setState({ isSubmitting: true });

    const { from, to, amount, description } = this.state;

    http
      .post("/transfer", {
        source: from,
        target: to,
        symbol: "$tin",
        amount: amount + "",
        labels: {
          type: "SEND",
          description
        }
      })
      .then(() => {
        this.setState({
          isSubmitted: true,
          isTransferred: true,
          isSubmitting: false
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  renderForm() {
    const {
      amount,
      description,
      name,
      phoneNumber,
      errors,
      isSubmitting
    } = this.state;

    return (
      <form
        className="confirm-transfer-form"
        noValidate
        action=""
        onSubmit={this.handleSubmit}
      >
        <h1 className="confirm-transfer-title">New transfer</h1>
        <div className="confirm-transfer-to-panel">
          <span className="confirm-transfer-to-name">{name}</span>
          <span className="confirm-transfer-to-phone">+{phoneNumber}</span>
        </div>
        <div className="confirm-transfer-amount">COP {amount}</div>
        <div className="confirm-transfer-description">{description}</div>
        <div className="confirm-transfer-form">
          <div className="confirm-transfer-input-group">
            <p>Ingrese su código pin de 5 dígitos para confirmar</p>
            <div>
              <label className="confirm-transfer-label" htmlFor="pin">
                Código PIN
              </label>
              <input
                className="confirm-transfer-input"
                id="pin"
                name="pin"
                type="password"
                pattern="[0-9]*"
                inputMode="numeric"
                placeholder="00000"
                value={this.state.pin}
                onChange={this.handleChange}
                aria-invalid={this.state.errors.pin}
                autoComplete="off"
              />
            </div>
            {errors.pin && (
              <div className="confirm-transfer-input-error" aria-live="polite">
                Ingrese un código de 5 dígitos
              </div>
            )}
          </div>
          <button
            className="confirm-transfer-submit button-green"
            disabled={isSubmitting}
          >
            Confirmar
          </button>
        </div>
      </form>
    );
  }
  renderConfirmation() {
    const { amount, name, phoneNumber, description } = this.state;

    return (
      <div className="confirm-transfer-confirmation">
        <div className="confirm-transfer-confirmation-intro">
          Tu transferiste
        </div>
        <div className="confirm-transfer-confirmation-amount">
          <Price
            valueClassName="transfer-confirmation-amount-value"
            showDecimals={false}
          >
            {parseInt(amount, 10)}
          </Price>
        </div>
        <div className="confirm-transfer-confirmation-to">
          <div className="confirm-transfer-confirmation-to-label">a</div>
          <div className="confirm-transfer-confirmation-to-name">{name}</div>
          <div className="confirm-transfer-confirmation-to-phone">
            +{phoneNumber}
          </div>
        </div>
        <div className="confirm-transfer-confirmation-description">
          {description}
        </div>
        <Link to="/">volver a la página de resumen</Link>
      </div>
    );
  }

  render() {
    const { isTransferred } = this.state;

    return (
      <div className="confirm-transfer">
        {!isTransferred && this.renderForm()}
        {isTransferred && this.renderConfirmation()}
      </div>
    );
  }
}

ConfirmTransfer.contextTypes = {
  isSignedIn: PropTypes.bool
};

export default ConfirmTransfer;



// WEBPACK FOOTER //
// ./src/ConfirmTransfer/ConfirmTransfer.js